// extracted by mini-css-extract-plugin
module.exports = {"emptyStateRoot":"UvKKIqcx","description":"Wp9Ug4Lo"};